import { combine, withContext, withAsyncEffect } from 'react-hooks-combine'
import { StoreContext } from 'store/context'

import TeamDetailsPanelComponent from './component'

export const TeamDetailsPanel = combine(
  withContext('teamsStore', StoreContext, ({ teams }) => teams),
  withAsyncEffect({
    deps: ['teamId'],
    dataName: 'team',
    loadingName: 'loadingTeam',
    errorName: 'teamError',
    asyncAction({ teamsStore }, { teamId }) {
      return teamsStore.loadOne(teamId)
    },
  }),
  // TODO: Temp solution
  withAsyncEffect({
    deps: ['team'],
    dataName: 'athletes',
    loadingName: 'loadingAthletes',
    errorName: 'athleteError',
    async asyncAction({ team }) {
      if (team) {
        return team.loadAthletes()
      }
    },
  })
)(TeamDetailsPanelComponent)
